import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class FibreTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('FibreTypeReference');
  }
}
